import styled from "styled-components";

export const Row = styled.div`
  height: 100%;
  position: relative;
  ${(props) =>
    props.header && `padding-top: ${props?.isDesktop ? "52px" : "50px"};`}
  margin: auto;
  ${(props) =>
    props?.isDesktop &&
    `
      max-width: 550px;
      height: auto !important;
    ${
      props?.theme?.isDarkTheme
        ? "box-shadow: 0 0 7px 1px #393939;"
        : "box-shadow: 0 0 5px 2px #d7d7d7;"
    }
    
    min-height: 750px;
    `}

  ${(props) =>
    props.header &&
    `
      @media screen and (max-width: 767px) and (min-width: 600px ) {
        padding-top: 62px !important;
      }
    `}
`;

export const Col = styled.div`
  height: ${(props) => (props?.isDesktop ? "auto" : "100%")};
`;
